var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelojRelojG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.3 53.6",
    style: {
      enableBackground: "new 0 0 47.3 53.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#707070;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.4,48.4c-0.3-0.5-1-0.6-1.4-0.3c-3.3,2.2-7.2,3.3-11.2,3.3c-11.4,0-20.6-9.3-20.6-20.6 c0-4.1,1.2-8.1,3.5-11.5c0.3-0.5,0.2-1.1-0.3-1.5c-0.5-0.3-1.1-0.2-1.5,0.3C1.3,21.9,0,26.3,0,30.8c0,6.1,2.4,11.8,6.7,16.1 s10,6.7,16.1,6.7c4.4,0,8.7-1.3,12.4-3.7C35.6,49.6,35.7,48.9,35.4,48.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,16c-0.6,0-1,0.5-1,1v2.3c0,0.6,0.5,1,1,1s1-0.5,1-1V17C23.8,16.5,23.3,16,22.7,16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,20.3C33,20.2,32.7,20,32.5,20s-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7 c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7S33.4,20.5,33.2,20.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,29.8h-2.3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1h2.3c0.6,0,1-0.5,1-1C37.6,30.3,37.1,29.8,36.5,29.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,39.8c-0.2-0.2-0.5-0.3-0.7-0.3s-0.5,0.1-0.7,0.3s-0.3,0.5-0.3,0.7s0.1,0.5,0.3,0.7 c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3s0.3-0.5,0.3-0.7S33.4,40,33.2,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,41.3c-0.6,0-1,0.5-1,1v2.3c0,0.6,0.5,1,1,1s1-0.5,1-1v-2.3C23.8,41.7,23.3,41.3,22.7,41.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,39.8c-0.2-0.2-0.5-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3S12,40.3,12,40.5s0.1,0.5,0.3,0.7s0.5,0.3,0.7,0.3 c0.3,0,0.5-0.1,0.7-0.3s0.3-0.5,0.3-0.7S13.9,40,13.7,39.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.2,29.8H8.9c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1h2.3c0.6,0,1-0.5,1-1C12.3,30.3,11.8,29.8,11.2,29.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,20.3C13.5,20.2,13.3,20,13,20s-0.5,0.1-0.7,0.3C12.1,20.5,12,20.8,12,21c0,0.3,0.1,0.5,0.3,0.7 S12.8,22,13,22c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7S13.9,20.5,13.7,20.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.9,22.7c-0.3-0.3-0.9-0.4-1.3-0.2L21,27.7c-0.1,0.1-0.2,0.1-0.3,0.2c-0.9,0.6-1.5,1.7-1.5,2.9 c0,2,1.6,3.6,3.6,3.6c1.2,0,2.2-0.6,2.9-1.5c0.1-0.1,0.1-0.2,0.2-0.3l5.2-8.6C31.3,23.5,31.2,23,30.9,22.7 M24,31.5l-0.1,0.1 c-0.3,0.4-0.7,0.6-1.2,0.6c-0.8,0-1.5-0.7-1.5-1.5c0-0.5,0.3-0.9,0.6-1.2l0.1-0.1c0.2-0.1,0.4-0.2,0.7-0.2c0.8,0,1.5,0.7,1.5,1.5 C24.2,31.1,24.1,31.3,24,31.5 M25.7,28.8c-0.2-0.4-0.6-0.7-0.9-0.9l2.3-1.4L25.7,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,12.7c-10,0-18.1,8.1-18.1,18.1S12.7,49,22.7,49s18.1-8.1,18.1-18.1S32.7,12.7,22.7,12.7 M22.7,46.9 c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16S31.6,46.9,22.7,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,14.7c-0.2-0.2-0.5-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.5-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7 c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7C8.5,15.2,8.4,14.9,8.2,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.9,45.3c-0.4-0.4-1.1-0.4-1.5,0l0,0c-0.4,0.4-0.4,1.1,0,1.5c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3 l0,0C39.4,46.3,39.4,45.7,38.9,45.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,17.1c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l1.7-1.7c1.2-1.2,1.2-3.3,0-4.5l-3.7-3.7 c-0.6-0.6-1.4-0.9-2.3-0.9c-0.9,0-1.7,0.3-2.3,0.9l-1.7,1.7C36.1,9.1,36,9.4,36,9.6c0,0.3,0.1,0.5,0.3,0.7l0.5,0.5l-1.3,1.3 C33,10.3,30,9,26.8,8.5V6.7h2.3c0.6,0,1-0.5,1-1V1c0-0.6-0.5-1-1-1H16.3c-0.6,0-1,0.5-1,1v4.6c0,0.6,0.5,1,1,1h2.3v1.8 c-3,0.5-5.9,1.7-8.4,3.4c-0.5,0.3-0.6,1-0.3,1.5s1,0.6,1.5,0.3c3.4-2.2,7.3-3.4,11.3-3.4c11.4,0,20.6,9.3,20.6,20.6 c0,3.9-1.1,7.6-3.1,10.9c-0.3,0.5-0.2,1.1,0.3,1.4c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.7-0.2,0.9-0.5c2.2-3.6,3.4-7.7,3.4-12 c0-4.7-1.4-9.2-4-12.9l1.3-1.3L43.2,17.1z M24.7,8.2c-0.7-0.1-1.3-0.1-2-0.1s-1.3,0-2,0.1V6.7h4V8.2z M19.7,4.6h-2.3V2.1h10.7v2.5 H19.7z M40.1,16.2c-0.4-0.5-0.9-1-1.3-1.5c-0.5-0.5-1-0.9-1.5-1.3l1.1-1.1l2.8,2.8L40.1,16.2z M39.1,10.1L39.1,10.1l-0.5-0.5l1-1 c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3l3.7,3.7c0.4,0.4,0.4,1.1,0,1.5l-1,1l-0.5-0.5l0,0L39.1,10.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelojRelojG);
export default __webpack_public_path__ + "static/media/reloj_reloj-g.24fcc0801c1b8e99790186fe851f6998.svg";
export { ForwardRef as ReactComponent };